<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'grid-comp.feed-in-operation' | translate"
          [tooltip]="'tooltips.technical-data.feed-in-operation' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="section-wrapper margin-align" [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'">
    <div class="top-bottom-margin section-column">
      <div class="section-field">
        <p-radioButton
          name="type_of_feed_in"
          value="completeFeedIn"
          [(ngModel)]="technicalData.type_of_feed_in"
          #type_of_feed_in="ngModel"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label class="ml-2">
          {{ 'grid-comp.complete-feed-in' | translate }}
        </label>
      </div>
      <div *ngIf="technicalData.type_of_feed_in && technicalData.type_of_feed_in != 'excessFeedIn'" class="section-field ml-3">
        <p-radioButton
          name="type_of_complete_feed_in"
          value="directFeedIn"
          [(ngModel)]="technicalData.type_of_complete_feed_in"
          #type_of_complete_feed_in="ngModel"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label class="ml-2">
          {{ 'grid-comp.direct-feed-in' | translate }}
        </label>
      </div>
      <div *ngIf="technicalData.type_of_feed_in && technicalData.type_of_feed_in != 'excessFeedIn'" class="section-field ml-3">
        <p-radioButton
          name="type_of_complete_feed_in"
          value="clientOwnedPowerPlant"
          [(ngModel)]="technicalData.type_of_complete_feed_in"
          #type_of_complete_feed_in="ngModel"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label class="ml-2">
          {{ 'grid-comp.financial-clearing' | translate }}
        </label>
      </div>
      <div class="section-field">
        <p-radioButton
          name="type_of_feed_in"
          value="excessFeedIn"
          [(ngModel)]="technicalData.type_of_feed_in"
          (ngModelChange)="resetFeedInType()"
          #type_of_feed_in="ngModel"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label class="ml-2">
          {{ 'grid-comp.excess-feed-in' | translate }}
        </label>
      </div>
    </div>
  </div>
</div>
